import { PremiumDescriptionTextModule } from '../../components/premium/description-text/premium-description-text.module';
import { AdditionalContentModalComponent } from './modals/additional-content-modal/additional-content-modal.component';
import { NewPhotoNotificationModule } from '../../components/new-photo-notification/new-photo-notification.module';
import { ChatIsFinishedModalComponent } from './modals/chat-is-finished-modal/chat-is-finished-modal.component';
import { SaveProgressToastModule } from '../../components/save-progress-toast/save-progress-toast.module';
import { PremiumButtonTextModule } from '../../components/premium/button-text/premium-button-text.module';
import { AudioMessageComponent } from './message-templates/audio-message/audio-message.component';
import { PhotoMessageComponent } from './message-templates/photo-message/photo-message.component';
import { VideoMessageComponent } from './message-templates/video-message/video-message.component';
import { PremiumBlockModule } from '../../components/premium/premium-block/premium-block.module';
import { TextMessageComponent } from './message-templates/text-message/text-message.component';
import { AiOfflineModalComponent } from './modals/ai-offline-modal/ai-offline-modal.component';
import { AdMessageComponent } from './message-templates/ad-message/ad-message.component';
import { PriceBlockModule } from '../../components/price-block/price-block.module';
import { ChatAnswerInputComponent } from './answer-input/answer-input.component';
import { GiftsModalComponent } from './modals/gifts-modal/gifts-modal.component';
import { RatingBarModule } from '../../components/rating-bar/rating-bar.module';
import { ChatModalComponent } from './modals/chat-modal/chat-modal.component';
import { ButtonModule } from '../../components/controls/button/button.module';
import { ChatGalleryComponent } from './chat-gallery/chat-gallery.component';
import { ChatPreviewComponent } from './chat-preview/chat-preview.component';
import { TutorialModule } from '../../components/tutorial/tutorial.module';
import { DirectivesModule } from '../../directives/directives.module';
import { HeaderModule } from '../../components/header/header.module';
import { EmojiModule } from '../../components/emoji/emoji.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OfflineComponent } from './offline/offline.component';
import { PipesModule } from '../../pipes/pipes.module';
import { TranslateModule } from '@ngx-translate/core';
import { BanComponent } from './ban/ban.component';
import { ChatComponent } from './chat.component';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { AiPaywallComponent } from './modals/ai-paywall/ai-paywall.component';
import { SwiperModule } from 'swiper/angular';

@NgModule({
  declarations: [
    AdditionalContentModalComponent,
    ChatIsFinishedModalComponent,
    ChatAnswerInputComponent,
    AiOfflineModalComponent,
    PhotoMessageComponent,
    AudioMessageComponent,
    VideoMessageComponent,
    ChatGalleryComponent,
    ChatPreviewComponent,
    TextMessageComponent,
    GiftsModalComponent,
    ChatModalComponent,
    AiPaywallComponent,
    AdMessageComponent,
    OfflineComponent,
    ChatComponent,
    BanComponent,
  ],
  imports: [
    PremiumDescriptionTextModule,
    NewPhotoNotificationModule,
    SaveProgressToastModule,
    PremiumButtonTextModule,
    ReactiveFormsModule,
    PremiumBlockModule,
    DirectivesModule,
    PriceBlockModule,
    TranslateModule,
    RatingBarModule,
    TutorialModule,
    CommonModule,
    HeaderModule,
    RouterModule,
    ButtonModule,
    SwiperModule,
    FormsModule,
    PipesModule,
    IonicModule,
    EmojiModule,
    FormsModule,
  ],
  exports: [ChatComponent, ChatAnswerInputComponent],
})
export class ChatModule {}
